import React from 'react';
import NCConverter from '../components/features/nc-conversion/NCConverter';

/**
 * NC変換ページコンポーネント
 * NC変換機能のメインページを提供する
 */
export const NCConversionPage: React.FC = () => {
  // region: レンダリング処理
  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">NC変換</h1>
      <NCConverter />
    </div>
  );
  // endregion
};

export default NCConversionPage;